import { render, staticRenderFns } from "./batchDownload.vue?vue&type=template&id=79d0b963&scoped=true"
import script from "./batchDownload.vue?vue&type=script&lang=js"
export * from "./batchDownload.vue?vue&type=script&lang=js"
import style0 from "./batchDownload.vue?vue&type=style&index=0&id=79d0b963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d0b963",
  null
  
)

export default component.exports